import { sidebarStore } from "@/store/sidebar"

import { setOpen, toggle } from "../actions/sidebar-actions"
import { SidebarState } from "../types"

export function useSidebar(): SidebarState {
  const state = sidebarStore()

  return {
    ...state,
    setOpen,
    toggle,
  }
}
